import { styled } from "styled-components";

const Container = styled.div<{ $variant?: 'default' | 'transparent' }>`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  min-width: 240px;
  width: 100%;
  background: ${({ $variant, theme }) => $variant === 'transparent' ? 'transparent' : `${theme?.colors?.theme?.contentBg}`};
`;

const Icon = styled.img`
  width: 80px;
  height: 80px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  font-family: 'Red Hat Display', sans-serif;
  line-height: 120%;
  font-size: 0.875rem;
  margin: 0;
  font-weight: 400;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
`;

const Description = styled.p`
  font-family: 'Red Hat Display', sans-serif;
  font-size: 1.5rem;
  margin: 0;
  font-weight: 700;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  line-height: 200%;
`;

const DetailText = styled.p`
  font-family: 'Red Hat Display', sans-serif;
  font-size: 0.75rem;
  font-weight: normal;
  color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  margin-top: 8px;
  cursor: pointer;
`;

export {
  Container,
  Description,
  DetailText,
  Icon,
  TextContainer,
  Title,
};

